import { lazy, Suspense } from 'react';

import { Loader } from 'shared';
import lazyRetry from 'shared_DEPRECATED/utils/lazyRetry';

import { SIZES } from 'shared/components/Modal';
import { useOpenModal } from 'shared/components/Modal/hooks';

const SessionsRecapModal = lazy(() =>
  lazyRetry(async () => {
    const module = await import('features/sessions/components/RecapModal');
    return { default: module.SessionsRecapModal };
  }, 'SessionsRecapModal')
);

type SessionRecapModalInput = {
  title: string;
  content: string;
  submittedAt: string;
  coachProfile?: {
    picture: { url: string };
    name: string;
  };
  attachments: { url?: string; name: string }[];
};

export const useOpenSessionRecapModal = (
  sessionRecap: SessionRecapModalInput
) => {
  return useOpenModal({
    content: (
      <Suspense
        fallback={<Loader data-testid="sessions-recap-dialog-loader" />}
      >
        <SessionsRecapModal />
      </Suspense>
    ),
    props: {
      size: SIZES.LG,
      title: 'Session Recap',
    },
    context: { sessionRecap },
  });
};
